module.exports = __webpack_public_path__ + "static/android-icon-192x192-c973b492d3e45fd3768348d85ed1f5d9.png";